exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".instructions {\n  font-family: \"Source Sans Pro\", \"Helvetica Neue\", \"Helvetica\";\n  font-size: 1em;\n  color: #365e63;\n  text-align: center;\n  letter-spacing: normal;\n  word-spacing: normal; }\n\n.instructions-spacing {\n  margin-top: -40px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./src/js/components/Instructions/instructions.scss
// module id = 257
// module chunks = 0